import { Icon } from '@aqarmap/aqarmap-ui';
import React from 'react';
import { useTranslation } from 'react-i18next';

const CopyButton = ({ text }: { text: string }) => {
  const { t } = useTranslation('app');
  const [copied, setCopied] = React.useState(false);

  const handleCopy = () => {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        setCopied(true);
        setTimeout(() => setCopied(false), 5000);
      })
      .catch((err) => {
        console.error('Failed to copy text: ', err);
      });
  };

  return (
    <button
      className={`${copied ? 'text-green_dark' : 'text-gray__dark_2'} border border-gray px-1.5x py-2x rounded-[12px] flex gap-1.5x`}
      onClick={handleCopy}
    >
      {copied ? <Icon name="check" /> : <Icon name="copy" />}
      <span className="text-gray__dark_1">
        {copied ? t('copyTextSuccess') : t('copyText')}
      </span>
    </button>
  );
};

export default CopyButton;
